module.exports = __webpack_public_path__ + "img/share1.f99e9e28.png";